import "./index.scss";

import MUITab from "@mui/material/Tab";
import MUITabs from "@mui/material/Tabs";
import * as React from "react";
import { memo, useCallback } from "react";

interface TabsProps {
  value?: number | string;
  tabs?: {
    label: string;
    [key: string]: any;
  }[];
  rightComp?: React.ReactNode;
  onChange?: (value: any) => void;
  centered?: boolean;
  padding?: any;
  className?: string;
  style?: any;
}

const TabsComponent = (props: TabsProps) => {
  const {
    value = 0,
    tabs = [],
    rightComp,
    onChange,
    centered,
    padding,
    className,
    ...restProps
  } = props;

  const handleChange = useCallback(
    (event: React.SyntheticEvent, newValue: any) => {
      event.preventDefault();
      onChange && onChange(newValue);
    },
    [onChange]
  );

  return (
    <div className={`tab-container ${centered ? "centered" : ""} ${className || ""}`.trim()}>
      <MUITabs value={value} onChange={handleChange} {...restProps}>
        {tabs.map((item, index) => {
          let extraProps = {};
          if (item["value"]) {
            extraProps = { value: item["value"] };
          }
          return (
            <MUITab
              key={index}
              label={item.label}
              disabled={item.disabled}
              disableRipple
              className={item.state || ``}
              {...extraProps}
            />
          );
        })}
      </MUITabs>
      <div className="right">{rightComp}</div>
    </div>
  );
};

const Tabs = memo(TabsComponent);
export default Tabs;
